import React, { useEffect, createElement } from 'react';
import { Hero } from './components/Hero';
import { SocialProof } from './components/SocialProof';
import { Testimonials } from './components/Testimonials';
import { ProblemSection } from './components/ProblemSection';
import { TomosSection } from './components/TomosSection';
import { BonusSection } from './components/BonusSection';
import { CountdownTimer } from './components/CountdownTimer';
import { PricingSection } from './components/PricingSection';
import { AulaListaSection } from './components/AulaListaSection';
import { ComparisonTableExtended } from './components/ComparisonTableExtended';
import { TestimonialsPreGuarantee } from './components/TestimonialsPreGuarantee';
import { ProductCarousel } from './components/ProductCarousel';
import { Guarantee } from './components/Guarantee';
import { FAQ } from './components/FAQ';
import { ComparisonTable } from './components/ComparisonTable';
import { FinalCTA } from './components/FinalCTA';
import { PurchasePopup } from './components/PurchasePopup';
export function App() {
  useEffect(() => {
    // Google Tag
    const script1 = document.createElement('script');
    script1.async = true;
    script1.src = 'https://www.googletagmanager.com/gtag/js?id=G-37GBY6792M';
    document.head.appendChild(script1);
    const script2 = document.createElement('script');
    script2.innerHTML = `
      window.dataLayer = window.dataLayer || [];
      function gtag(){dataLayer.push(arguments);}
      gtag('js', new Date());
      gtag('config', 'G-37GBY6792M');
    `;
    document.head.appendChild(script2);
    // Meta Pixel
    const fbScript = document.createElement('script');
    fbScript.innerHTML = `
      !function(f,b,e,v,n,t,s)
      {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
      n.callMethod.apply(n,arguments):n.queue.push(arguments)};
      if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
      n.queue=[];t=b.createElement(e);t.async=!0;
      t.src=v;s=b.getElementsByTagName(e)[0];
      s.parentNode.insertBefore(t,s)}(window, document,'script',
      'https://connect.facebook.net/en_US/fbevents.js');
      fbq('init', '1687764378881323');
      fbq('track', 'PageView');
    `;
    document.head.appendChild(fbScript);
    const fbNoscript = document.createElement('noscript');
    fbNoscript.innerHTML = `<img height="1" width="1" style="display:none" src="https://www.facebook.com/tr?id=1687764378881323&ev=PageView&noscript=1" />`;
    document.body.appendChild(fbNoscript);
  }, []);
  return <div className="min-h-screen bg-white font-sans selection:bg-brand-gold selection:text-white text-slate-900" data-id="element-0">
      <Hero data-id="element-1" />
      <SocialProof data-id="element-2" />
      <Testimonials data-id="element-3" />
      <ProblemSection data-id="element-4" />
      <TomosSection data-id="element-5" />
      <BonusSection data-id="element-6" />
      <ProductCarousel data-id="element-7" />
      <CountdownTimer data-id="element-8" />
      <PricingSection data-id="element-9" />
      <AulaListaSection data-id="element-10" />
      <ComparisonTableExtended data-id="element-11" />
      <TestimonialsPreGuarantee data-id="element-12" />
      <Guarantee data-id="element-13" />
      <FAQ data-id="element-14" />
      <ComparisonTable data-id="element-15" />
      <FinalCTA data-id="element-16" />

      <div className="max-w-xl mx-auto px-5 py-12 text-center" data-id="element-17">
        <p className="text-slate-500 text-lg mb-4 italic" data-id="element-18">
          Esto no es solo aprender colorimetría…
        </p>
        <p className="text-2xl font-black mb-4 text-brand-gold" data-id="element-19">
          👉 es dejar de improvisar y empezar a trabajar con criterio técnico
          real.
        </p>
        <p className="text-slate-900 text-3xl font-black" data-id="element-20">
          💥 Y eso puede cambiarlo todo.
        </p>
      </div>

      <PurchasePopup data-id="element-21" />
    </div>;
}